var ConfigService = /** @class */ (function () {
    function ConfigService() {
    }
    // Default feature flag values can be given here. These will be valid in all environments
    // unless overridden in the config files or via url query.
    // If property needs to be configurable via url, default value is mandatory.
    ConfigService.features = {
        showDraftStatusFilter: false,
    };
    return ConfigService;
}());
export { ConfigService };
